var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3437 23.4C18.8873 26.5875 21.4648 29.1584 24.6562 30.6937C24.8917 30.8052 25.1521 30.8535 25.4118 30.8337C25.6715 30.814 25.9216 30.727 26.1375 30.5813L30.825 27.45C31.0321 27.3095 31.2714 27.2238 31.5206 27.2009C31.7698 27.1779 32.0207 27.2185 32.25 27.3187L41.025 31.0875C41.3249 31.2123 41.5755 31.4323 41.7381 31.7135C41.9007 31.9947 41.9664 32.3216 41.925 32.6438C41.6469 34.8145 40.5873 36.8096 38.9446 38.2556C37.3018 39.7016 35.1885 40.4995 33 40.5C26.237 40.5 19.751 37.8134 14.9688 33.0312C10.1866 28.249 7.5 21.763 7.5 15C7.50049 12.8115 8.2984 10.6982 9.74442 9.05542C11.1904 7.41268 13.1855 6.35312 15.3562 6.075C15.6784 6.03361 16.0053 6.09929 16.2865 6.26191C16.5677 6.42454 16.7877 6.6751 16.9125 6.975L20.6812 15.7688C20.7793 15.9944 20.8203 16.2407 20.8006 16.4859C20.781 16.7312 20.7014 16.9678 20.5687 17.175L17.4375 21.9375C17.2981 22.1529 17.2163 22.4005 17.1999 22.6565C17.1834 22.9126 17.233 23.1686 17.3437 23.4V23.4Z",
    stroke: "#FCFCFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.3f5aec4d4074d3d68f55096e70246ece.svg";
export { ForwardRef as ReactComponent };